import { render, staticRenderFns } from "./MixedCells.vue?vue&type=template&id=7155486a&scoped=true&"
import script from "./MixedCells.vue?vue&type=script&lang=js&"
export * from "./MixedCells.vue?vue&type=script&lang=js&"
import style0 from "./MixedCells.vue?vue&type=style&index=0&id=7155486a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155486a",
  null
  
)

export default component.exports